<template>
  <el-card>
    <span class="title">平台题库</span>
    <div style="margin-top:30px;">
      <el-input
        style="width:30%;"
        placeholder="请输入内容"
        prefix-icon="el-icon-search"
        v-model="query.title"
      >
      </el-input>
      <el-button
        icon="el-icon-search"
        type="primary"
        style="margin-left:12px;"
        @click="search"
      >
        查询
      </el-button>
    </div>

    <el-table :data="tableData" border stripe>
      <el-table-column type="index" label="#"></el-table-column>
      <el-table-column prop="Id" label="题型"></el-table-column>
      <el-table-column prop="title" label="题目"></el-table-column>
      <el-table-column prop="introduce" label="答案"></el-table-column>
      <el-table-column prop="introduce" label="解析"></el-table-column>
      <el-table-column label="操作" min-width="80">
        <template slot-scope="scope">
          <el-button
            type="warning"
            icon="el-icon-edit"
            size="mini"
            @click="edit_question(scope.row)"
          >
            修改
          </el-button>
          <el-button
            type="danger"
            icon="el-icon-delete"
            size="mini"
            @click="delete_question(scope.row, scope.$index)"
          >
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
  </el-card>
</template>

<script>
import { get_question_api } from "@/api/question.js";
export default {
  data() {
    return {
      tableData: [],
      query: { title: "" },
    };
  },
  created() {
    this.get_question();
  },
  methods: {
    //获取试题
    get_question() {
      get_question_api().then((res) => {
        console.log(res);
      });
    },

    //预览
    preview(item) {
      console.log(item);
    },

    //查询
    search() {},
  },
};
</script>

<style lang="stylus" scoped>
.el-card {
  .title {
      color:#333;
      font-size:20px;
  }
  margin:16px;
  .el-table {
    margin-top:15px;
  }
}
</style>
